<template>
  <div>
    <div
      ref="text"
      class="transition text-trans"
      aria-hidden="true"
    >
      {{ getText }}
    </div>
    <button
      v-if="shouldShowReadMore"
      class="font-medium text-underline cursor-pointer focus:outline-none"
      type="button"
      @click="showMore"
    >
      {{ $t('app.read-more') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'VetsterReadMore',

  props: {
    text: {
      required: false,
      type: String,
      default: '',
    },
    cutoff: {
      required: true,
      type: Number,
    },
    animated: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      body: this.text,
      readMore: false,
    };
  },

  computed: {
    shouldTrim() {
      return this.body.length > this.cutoff;
    },
    shouldShowReadMore() {
      return this.shouldTrim && !this.readMore;
    },
    getText() {
      if (!this.shouldTrim) {
        return this.body;
      }

      return this.readMore ? this.body : `${this.body.substring(0, this.cutoff)}...`;
    },
  },

  mounted() {
    if (this.body === '') {
      this.body = this.$slots.default.map((node) => node.text).toString();
    }

    this.calculateHeight();
  },

  methods: {
    calculateHeight() {
      if (!this.animated) return;
      this.$nextTick(() => {
        const element = this.$refs.text;
        const oldHeight = getComputedStyle(element).height;
        const { width } = getComputedStyle(element);

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const { height } = getComputedStyle(element);

        element.style.width = null;
        element.style.position = null;
        element.style.visibility = null;
        element.style.height = oldHeight;

        // Force repaint to make sure the
        // animation is triggered correctly.
        // eslint-disable-next-line no-unused-expressions
        getComputedStyle(element).height;

        // Trigger the animation.
        // We use `requestAnimationFrame` because we need
        // to make sure the browser has finished
        // painting after setting the `height`
        // to `0` in the line above.
        requestAnimationFrame(() => {
          element.style.height = height;
        });
      });
    },
    showMore() {
      this.readMore = true;
      this.$emit('show-more');
      this.calculateHeight();
    },
  },
};
</script>

<style scoped>
.text-trans{
  transition: height 0.5s ease-in-out;
  overflow: hidden;
}
</style>
